import gql from "graphql-tag";
import * as VueApolloComposable from "@vue/apollo-composable";
import * as VueCompositionApi from "@vue/composition-api";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    AWSURL: any;
};

export type Account = {
    __typename?: "Account";
    dateCreated: Scalars["String"];
    email?: Maybe<Scalars["String"]>;
    isInternalUser: Scalars["Boolean"];
    phoneNumber?: Maybe<Scalars["String"]>;
    username: Scalars["String"];
};

export type Analytics = {
    __typename?: "Analytics";
    funnel: Scalars["String"];
};

export type AnalyticsEventInput = {
    action: Scalars["String"];
    campaignID: Scalars["String"];
};

export type Audio = {
    __typename?: "Audio";
    url: Scalars["AWSURL"];
};

export type AudioInput = {
    name: Scalars["String"];
    provider: Scalars["ID"];
};

export type CsatData = {
    __typename?: "CSATData";
    fiveStarCount: Scalars["Int"];
    fourStarCount: Scalars["Int"];
    oneStarCount: Scalars["Int"];
    threeStarCount: Scalars["Int"];
    twoStarCount: Scalars["Int"];
};

export type Campaign = {
    __typename?: "Campaign";
    CSATQuestion?: Maybe<Scalars["String"]>;
    NPSQuestion?: Maybe<Scalars["String"]>;
    agentWelcomeMessage?: Maybe<Scalars["String"]>;
    aiMetrics?: Maybe<Scalars["String"]>;
    backgroundColor?: Maybe<Scalars["String"]>;
    backgroundImage?: Maybe<Image>;
    boostWords?: Maybe<Scalars["String"]>;
    collectEmails: CollectUserData;
    collectImages: CollectUserData;
    collectNames: CollectUserData;
    color?: Maybe<Scalars["String"]>;
    consentText?: Maybe<Scalars["String"]>;
    contributionURL?: Maybe<Scalars["String"]>;
    conversationalSurvey: Scalars["Boolean"];
    enabledWidgets: Array<Maybe<Scalars["String"]>>;
    enforcesPrivacyPolicyConsent: Scalars["Boolean"];
    enforcesTermsAndConditionsConsent: Scalars["Boolean"];
    hideBeamsBranding: Scalars["Boolean"];
    id: Scalars["ID"];
    image?: Maybe<Image>;
    interfaceLanguage?: Maybe<Scalars["String"]>;
    isCSATCampaign: Scalars["Boolean"];
    isNPSCampaign: Scalars["Boolean"];
    maximumRecordingDuration?: Maybe<Scalars["Int"]>;
    name: Scalars["String"];
    newRecorder: Scalars["Boolean"];
    numberOfVoices: Scalars["Int"];
    privacyPolicyConsentText?: Maybe<Scalars["String"]>;
    privacyText: Scalars["String"];
    promptSublineText?: Maybe<Scalars["String"]>;
    promptText?: Maybe<Scalars["String"]>;
    recordButtonLabel?: Maybe<Scalars["String"]>;
    responsesMetaSummary?: Maybe<Scalars["String"]>;
    status: Scalars["String"];
    successLink?: Maybe<Scalars["String"]>;
    successLinkLabel?: Maybe<Scalars["String"]>;
    successShareEnabled?: Maybe<Scalars["Boolean"]>;
    successText?: Maybe<Scalars["String"]>;
    termsAndConditionsConsentText?: Maybe<Scalars["String"]>;
    termsText: Scalars["String"];
    textFieldDefault: Scalars["Boolean"];
    timestampActivated?: Maybe<Scalars["String"]>;
    timestampArchived?: Maybe<Scalars["String"]>;
    timestampCreated: Scalars["String"];
    timestampDeactivated?: Maybe<Scalars["String"]>;
    timestampModified?: Maybe<Scalars["String"]>;
    videoURLs?: Maybe<Array<Maybe<Scalars["String"]>>>;
    widgetConfigs?: Maybe<Scalars["String"]>;
};

export type CampaignAnalytics = {
    __typename?: "CampaignAnalytics";
    brandLoyaltyCount: Scalars["Int"];
    buyAgainNoCount: Scalars["Int"];
    buyAgainYesCount: Scalars["Int"];
    contributionHistogram: Array<ContributionHistogramBin>;
    csat?: Maybe<CsatData>;
    disappointedCount: Scalars["Int"];
    genderCountFemale: Scalars["Int"];
    genderCountMale: Scalars["Int"];
    genderCountUndetermined: Scalars["Int"];
    greatForMarketing?: Maybe<Array<PostWithSensitiveData>>;
    lastPost?: Maybe<PostWithSensitiveData>;
    locationCityCount: Array<CampaignAnalyticsLocationCount>;
    locationCountryCount: Array<CampaignAnalyticsLocationCount>;
    locationRegionCount: Array<CampaignAnalyticsLocationCount>;
    nps?: Maybe<NpsData>;
    passionateCount: Scalars["Int"];
    requiresFollowup?: Maybe<Array<PostWithSensitiveData>>;
    satisfactionCount: Scalars["Int"];
    sentimentCountMixed: Scalars["Int"];
    sentimentCountNegative: Scalars["Int"];
    sentimentCountNeutral: Scalars["Int"];
    sentimentCountPositive: Scalars["Int"];
    sentimentCountUndetermined: Scalars["Int"];
};

export type CampaignAnalyticsLocationCount = {
    __typename?: "CampaignAnalyticsLocationCount";
    count: Scalars["Int"];
    country: Scalars["String"];
    name: Scalars["String"];
};

export type CampaignCreateInput = {
    CSATQuestion?: InputMaybe<Scalars["String"]>;
    NPSQuestion?: InputMaybe<Scalars["String"]>;
    interfaceLanguage?: InputMaybe<Scalars["String"]>;
    isCSATCampaign?: InputMaybe<Scalars["Boolean"]>;
    isNPSCampaign?: InputMaybe<Scalars["Boolean"]>;
    name: Scalars["String"];
    privacyText?: InputMaybe<Scalars["String"]>;
    promptText: Scalars["String"];
    termsText?: InputMaybe<Scalars["String"]>;
};

export type CampaignInsightMessage = {
    content: Scalars["String"];
    role: CampaignInsightMessageRole;
};

export enum CampaignInsightMessageRole {
    Assistant = "assistant",
    User = "user",
}

export type CampaignInsightResponse = {
    __typename?: "CampaignInsightResponse";
    answer: Scalars["String"];
};

export type CampaignPostsResponse = {
    __typename?: "CampaignPostsResponse";
    posts: Array<PostWithSensitiveData>;
    totalPostCount: Scalars["Int"];
};

export type CampaignUpdateInput = {
    CSATQuestion?: InputMaybe<Scalars["String"]>;
    NPSQuestion?: InputMaybe<Scalars["String"]>;
    agentWelcomeMessage?: InputMaybe<Scalars["String"]>;
    backgroundColor?: InputMaybe<Scalars["String"]>;
    backgroundImage?: InputMaybe<ImageInput>;
    boostWords?: InputMaybe<Scalars["String"]>;
    collectEmails?: InputMaybe<CollectUserData>;
    collectImages?: InputMaybe<CollectUserData>;
    collectNames?: InputMaybe<CollectUserData>;
    color?: InputMaybe<Scalars["String"]>;
    conversationalSurvey?: InputMaybe<Scalars["Boolean"]>;
    enabledWidgets?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    enforcesPrivacyPolicyConsent?: InputMaybe<Scalars["Boolean"]>;
    enforcesTermsAndConditionsConsent?: InputMaybe<Scalars["Boolean"]>;
    hideBeamsBranding?: InputMaybe<Scalars["Boolean"]>;
    image?: InputMaybe<ImageInput>;
    interfaceLanguage?: InputMaybe<Scalars["String"]>;
    maximumRecordingDuration?: InputMaybe<Scalars["Int"]>;
    name?: InputMaybe<Scalars["String"]>;
    newRecorder?: InputMaybe<Scalars["Boolean"]>;
    privacyPolicyConsentText?: InputMaybe<Scalars["String"]>;
    privacyText?: InputMaybe<Scalars["String"]>;
    promptSublineText?: InputMaybe<Scalars["String"]>;
    promptText?: InputMaybe<Scalars["String"]>;
    recordButtonLabel?: InputMaybe<Scalars["String"]>;
    status?: InputMaybe<Scalars["String"]>;
    successLink?: InputMaybe<Scalars["String"]>;
    successLinkLabel?: InputMaybe<Scalars["String"]>;
    successShareEnabled?: InputMaybe<Scalars["Boolean"]>;
    successText?: InputMaybe<Scalars["String"]>;
    termsAndConditionsConsentText?: InputMaybe<Scalars["String"]>;
    termsText?: InputMaybe<Scalars["String"]>;
    textFieldDefault?: InputMaybe<Scalars["Boolean"]>;
    videoURLs?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type Cluster = {
    __typename?: "Cluster";
    ids: Array<Scalars["String"]>;
    name: Scalars["String"];
};

export type ClusterResponse = {
    __typename?: "ClusterResponse";
    clusterSets: Array<ClusterSet>;
};

export type ClusterSet = {
    __typename?: "ClusterSet";
    classTypeID: Scalars["String"];
    classTypeName: Scalars["String"];
    clusters: Array<Cluster>;
};

export enum CollectUserData {
    Disabled = "disabled",
    Optional = "optional",
    Required = "required",
}

export type ContributionHistogramBin = {
    __typename?: "ContributionHistogramBin";
    count: Scalars["Int"];
    end: Scalars["String"];
    start: Scalars["String"];
};

export type CreateClassTypeResponse = {
    __typename?: "CreateClassTypeResponse";
    id: Scalars["String"];
};

export type CreatePostInput = {
    answer?: InputMaybe<Scalars["String"]>;
    audio?: InputMaybe<AudioInput>;
    campaignID: Scalars["String"];
    email?: InputMaybe<Scalars["String"]>;
    externalID?: InputMaybe<Scalars["String"]>;
    followupQuestions?: InputMaybe<Array<InputMaybe<FollowupQuestion>>>;
    image?: InputMaybe<ImageInput>;
    name?: InputMaybe<Scalars["String"]>;
    rating?: InputMaybe<Scalars["Int"]>;
};

export enum CreateUploadRequestAssetType {
    Audio = "AUDIO",
    Image = "IMAGE",
}

export type DeleteAccountResponse = {
    __typename?: "DeleteAccountResponse";
    success: Scalars["Boolean"];
};

export type DeletePostResponse = {
    __typename?: "DeletePostResponse";
    postID?: Maybe<Scalars["String"]>;
};

export type Environment = {
    __typename?: "Environment";
    customDomain?: Maybe<Scalars["String"]>;
    isBusinessTier: Scalars["Boolean"];
    isEnterpriseTier: Scalars["Boolean"];
    planName: Scalars["String"];
    postCountInCurrentPeriod: Scalars["Int"];
    postQuota: Scalars["Int"];
};

export type FilterParams = {
    fieldName: Scalars["String"];
    operator: Scalars["String"];
    value: Scalars["String"];
};

export type FollowupQuestion = {
    answer?: InputMaybe<Scalars["String"]>;
    question: Scalars["String"];
    timestamp: Scalars["Float"];
};

export type Image = {
    __typename?: "Image";
    color?: Maybe<Scalars["String"]>;
    urlTemplate: Scalars["AWSURL"];
};

export type ImageInput = {
    name: Scalars["String"];
};

export type IsHandleAvailable = {
    __typename?: "IsHandleAvailable";
    isAvailable: Scalars["Boolean"];
};

export type LinkInput = {
    imageURL?: InputMaybe<Scalars["String"]>;
    title: Scalars["String"];
    url: Scalars["AWSURL"];
};

export type Mutation = {
    __typename?: "Mutation";
    createCampaign: Campaign;
    /**   nexus facade for ms-brain (not ms-brain itself) */
    createClassType: CreateClassTypeResponse;
    createPDFExport: PdfExportResponse;
    createPost?: Maybe<Void>;
    createProfile: Profile;
    createProfileInvite: ProfileInvite;
    createSingleUseBillingURL: SingleUseBillingUrlResponse;
    /**   unauthenticated */
    createTranscribeStreamURL: TranscribeStreamUrlResponse;
    createUploadRequest: UploadRequest;
    deleteAccount: DeleteAccountResponse;
    deleteClassType?: Maybe<Void>;
    deletePost: DeletePostResponse;
    duplicateCampaign: Campaign;
    redeemProfileInvite: Void;
    saveAnalyticsEvent?: Maybe<Void>;
    setManagedProfile: Void;
    updateCampaign: Campaign;
    updatePost: PostWithSensitiveData;
    updatePostTranscript: PostWithSensitiveData;
    updateProfileV2: Profile;
};

export type MutationCreateCampaignArgs = {
    campaign: CampaignCreateInput;
};

export type MutationCreateClassTypeArgs = {
    campaignID: Scalars["String"];
    classTypeName: Scalars["String"];
    epsilon: Scalars["Float"];
};

export type MutationCreatePdfExportArgs = {
    url: Scalars["String"];
};

export type MutationCreatePostArgs = {
    post: CreatePostInput;
};

export type MutationCreateProfileArgs = {
    name: Scalars["String"];
    plan?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateTranscribeStreamUrlArgs = {
    campaignID: Scalars["String"];
};

export type MutationCreateUploadRequestArgs = {
    assetType: CreateUploadRequestAssetType;
    needsTranscoding?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationDeleteClassTypeArgs = {
    campaignID: Scalars["String"];
    classTypeID: Scalars["String"];
};

export type MutationDeletePostArgs = {
    postID: Scalars["String"];
};

export type MutationDuplicateCampaignArgs = {
    campaignID: Scalars["String"];
};

export type MutationRedeemProfileInviteArgs = {
    url: Scalars["String"];
};

export type MutationSaveAnalyticsEventArgs = {
    event: AnalyticsEventInput;
};

export type MutationSetManagedProfileArgs = {
    profileID: Scalars["String"];
};

export type MutationUpdateCampaignArgs = {
    campaign: CampaignUpdateInput;
    campaignID: Scalars["String"];
};

export type MutationUpdatePostArgs = {
    post: PostUpdateInput;
    postID: Scalars["String"];
};

export type MutationUpdatePostTranscriptArgs = {
    postID: Scalars["String"];
    words: Array<TranscriptWordInput>;
};

export type MutationUpdateProfileV2Args = {
    updateProfileInput?: InputMaybe<UpdateProfileInput>;
};

export type MyAccountsResponse = {
    __typename?: "MyAccountsResponse";
    accounts: Array<Account>;
};

export type NpsData = {
    __typename?: "NPSData";
    detractorsCount: Scalars["Int"];
    passivesCount: Scalars["Int"];
    promotersCount: Scalars["Int"];
};

export type PdfExportResponse = {
    __typename?: "PDFExportResponse";
    url: Scalars["String"];
};

/**   INPUT TYPE */
export type PaginationToken = {
    limit?: InputMaybe<Scalars["Int"]>;
    offset?: InputMaybe<Scalars["Int"]>;
};

export type Post = {
    __typename?: "Post";
    audio?: Maybe<Audio>;
    caption?: Maybe<Scalars["String"]>;
    contributorName?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    image?: Maybe<Image>;
    link?: Maybe<UrlPreview>;
    profile: Profile;
    rawTranscript?: Maybe<Scalars["String"]>;
    rawTranscriptProofRead?: Maybe<Scalars["String"]>;
    rawTranscriptTranslated?: Maybe<Scalars["String"]>;
    shareURL: Scalars["String"];
    shareVideoWithTranscriptURL?: Maybe<Scalars["String"]>;
    shopifyProductID?: Maybe<Scalars["String"]>;
    status: ResourceStatus;
    timestampCreated: Scalars["String"];
    timestampUserModified?: Maybe<Scalars["String"]>;
    transcript?: Maybe<Transcript>;
    transcriptLanguage?: Maybe<Scalars["String"]>;
    url: Scalars["String"];
};

export type PostUpdateInput = {
    bookmarked?: InputMaybe<Scalars["Boolean"]>;
    caption?: InputMaybe<Scalars["String"]>;
    contributorName?: InputMaybe<Scalars["String"]>;
    externalID?: InputMaybe<Scalars["String"]>;
    image?: InputMaybe<ImageInput>;
    link?: InputMaybe<LinkInput>;
    removeLink?: InputMaybe<Scalars["Boolean"]>;
    shopifyProductID?: InputMaybe<Scalars["String"]>;
    status?: InputMaybe<ResourceStatus>;
};

export type PostWithSensitiveData = {
    __typename?: "PostWithSensitiveData";
    aiMetrics?: Maybe<Scalars["String"]>;
    audio?: Maybe<Audio>;
    bookmarked?: Maybe<Scalars["Boolean"]>;
    caption?: Maybe<Scalars["String"]>;
    contributorEmail?: Maybe<Scalars["String"]>;
    contributorName?: Maybe<Scalars["String"]>;
    externalID?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    image?: Maybe<Image>;
    link?: Maybe<UrlPreview>;
    rating?: Maybe<Scalars["Int"]>;
    rawTranscript?: Maybe<Scalars["String"]>;
    rawTranscriptProofRead?: Maybe<Scalars["String"]>;
    rawTranscriptTranslated?: Maybe<Scalars["String"]>;
    shareURL: Scalars["String"];
    shareVideoWithTranscriptURL?: Maybe<Scalars["String"]>;
    shopifyProductID?: Maybe<Scalars["String"]>;
    status: ResourceStatus;
    summaryHeadline?: Maybe<Scalars["String"]>;
    summaryParagraph?: Maybe<Scalars["String"]>;
    timestampCreated: Scalars["String"];
    timestampUserModified?: Maybe<Scalars["String"]>;
    transcript?: Maybe<Transcript>;
    transcriptLanguage?: Maybe<Scalars["String"]>;
    url: Scalars["String"];
};

/**   Response types */
export type PostsResponse = {
    __typename?: "PostsResponse";
    posts: Array<Maybe<Post>>;
};

export type Profile = {
    __typename?: "Profile";
    boostWords?: Maybe<Scalars["String"]>;
    brandColor?: Maybe<Scalars["String"]>;
    brandLink?: Maybe<Scalars["String"]>;
    customFaviconImage?: Maybe<Image>;
    defaultPrivacyPolicyConsentText?: Maybe<Scalars["String"]>;
    defaultPrivacyText?: Maybe<Scalars["String"]>;
    defaultTermsAndConditionsConsentText?: Maybe<Scalars["String"]>;
    defaultTermsText?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    image?: Maybe<Image>;
    language: Scalars["String"];
    name?: Maybe<Scalars["String"]>;
    purchasedPlanID?: Maybe<Scalars["String"]>;
    shareURL: Scalars["String"];
    url: Scalars["String"];
    whiteLabelImage?: Maybe<Image>;
};

export type ProfileInvite = {
    __typename?: "ProfileInvite";
    profile: Profile;
    url: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type Query = {
    __typename?: "Query";
    analytics: Analytics;
    campaign: Campaign;
    campaignAnalytics: CampaignAnalytics;
    campaignInsight: CampaignInsightResponse;
    campaignPost: PostWithSensitiveData;
    campaignPosts: CampaignPostsResponse;
    campaignPostsV2: CampaignPostsResponse;
    /**   nexus facade for ms-brain (not ms-brain itself) */
    clusterSets: ClusterResponse;
    isHandleAvailable: IsHandleAvailable;
    myAccounts: MyAccountsResponse;
    myCampaigns: Array<Campaign>;
    myEnvironment: Environment;
    myProfile: Profile;
    myProfiles: Array<Profile>;
    post: Post;
    postByExternalIDAndProfileID?: Maybe<Scalars["String"]>;
    profileInvite: ProfileInvite;
    resourceV2: ResourceV2Response;
    urlPreview: UrlPreview;
};

/**   QUERIES AND MUTATIONS */
export type QueryAnalyticsArgs = {
    campaignID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignArgs = {
    campaignID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignAnalyticsArgs = {
    campaignID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignInsightArgs = {
    campaignID: Scalars["String"];
    previousMessages: Array<CampaignInsightMessage>;
    prompt: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignPostArgs = {
    postID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignPostsArgs = {
    campaignID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryCampaignPostsV2Args = {
    campaignID: Scalars["String"];
    paginationToken?: InputMaybe<PaginationToken>;
    queryOptions?: InputMaybe<QueryOptions>;
};

/**   QUERIES AND MUTATIONS */
export type QueryClusterSetsArgs = {
    campaignID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryIsHandleAvailableArgs = {
    handle: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryPostArgs = {
    postID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryPostByExternalIdAndProfileIdArgs = {
    externalID: Scalars["String"];
    profileID: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryProfileInviteArgs = {
    url: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryResourceV2Args = {
    url: Scalars["String"];
};

/**   QUERIES AND MUTATIONS */
export type QueryUrlPreviewArgs = {
    url: Scalars["String"];
};

export type QueryOptions = {
    filters?: InputMaybe<Array<InputMaybe<FilterParams>>>;
    searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ResourceCampaignContributionResponse = {
    __typename?: "ResourceCampaignContributionResponse";
    CSATQuestion?: Maybe<Scalars["String"]>;
    NPSQuestion?: Maybe<Scalars["String"]>;
    agentWelcomeMessage?: Maybe<Scalars["String"]>;
    backgroundColor?: Maybe<Scalars["String"]>;
    backgroundImage?: Maybe<Image>;
    canAcceptResponses: Scalars["Boolean"];
    collectEmails: CollectUserData;
    collectImages: CollectUserData;
    collectNames: CollectUserData;
    color?: Maybe<Scalars["String"]>;
    contributionURL: Scalars["String"];
    conversationalSurvey: Scalars["Boolean"];
    enabledWidgets: Array<Maybe<Scalars["String"]>>;
    enforcesPrivacyPolicyConsent: Scalars["Boolean"];
    enforcesTermsAndConditionsConsent: Scalars["Boolean"];
    hideBeamsBranding: Scalars["Boolean"];
    id: Scalars["ID"];
    image?: Maybe<Image>;
    interfaceLanguage?: Maybe<Scalars["String"]>;
    isCSATCampaign: Scalars["Boolean"];
    isNPSCampaign: Scalars["Boolean"];
    maximumRecordingDuration?: Maybe<Scalars["Int"]>;
    newRecorder: Scalars["Boolean"];
    privacyPolicyConsentText?: Maybe<Scalars["String"]>;
    privacyText: Scalars["String"];
    privacyURL?: Maybe<Scalars["String"]>;
    profile: Profile;
    promptSublineText?: Maybe<Scalars["String"]>;
    promptText?: Maybe<Scalars["String"]>;
    recordButtonLabel?: Maybe<Scalars["String"]>;
    status: Scalars["String"];
    successLink?: Maybe<Scalars["String"]>;
    successLinkLabel?: Maybe<Scalars["String"]>;
    successShareEnabled?: Maybe<Scalars["Boolean"]>;
    successText?: Maybe<Scalars["String"]>;
    termsAndConditionsConsentText?: Maybe<Scalars["String"]>;
    termsText: Scalars["String"];
    termsURL?: Maybe<Scalars["String"]>;
    textFieldDefault: Scalars["Boolean"];
    videoURLs?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type ResourcePostOnProfileResponse = {
    __typename?: "ResourcePostOnProfileResponse";
    post: Post;
};

export type ResourcePostResponse = {
    __typename?: "ResourcePostResponse";
    post: Post;
};

export type ResourceProfileResponse = {
    __typename?: "ResourceProfileResponse";
    profile: Profile;
};

export enum ResourceStatus {
    Private = "private",
    Processing = "processing",
    Public = "public",
    Removed = "removed",
}

export type ResourceV2Response = {
    __typename?: "ResourceV2Response";
    resource?: Maybe<ResourceV2ResponseResource>;
};

export type ResourceV2ResponseResource = ResourceCampaignContributionResponse | ResourcePostOnProfileResponse | ResourcePostResponse | ResourceProfileResponse;

export type SingleUseBillingUrlResponse = {
    __typename?: "SingleUseBillingURLResponse";
    url: Scalars["String"];
};

export type TranscribeStreamUrlResponse = {
    __typename?: "TranscribeStreamURLResponse";
    url: Scalars["String"];
};

export type Transcript = {
    __typename?: "Transcript";
    words: Array<TranscriptWord>;
};

export type TranscriptWord = {
    __typename?: "TranscriptWord";
    content: Scalars["String"];
    timeEnd?: Maybe<Scalars["Float"]>;
    timeStart?: Maybe<Scalars["Float"]>;
};

export type TranscriptWordInput = {
    content: Scalars["String"];
    timeEnd?: InputMaybe<Scalars["Float"]>;
    timeStart?: InputMaybe<Scalars["Float"]>;
};

export type UrlPreview = {
    __typename?: "URLPreview";
    imageURL?: Maybe<Scalars["String"]>;
    title: Scalars["String"];
    url: Scalars["String"];
};

export type UpdateProfileInput = {
    boostWords?: InputMaybe<Scalars["String"]>;
    brandColor?: InputMaybe<Scalars["String"]>;
    brandLink?: InputMaybe<Scalars["String"]>;
    defaultPrivacyPolicyConsentText?: InputMaybe<Scalars["String"]>;
    defaultPrivacyText?: InputMaybe<Scalars["String"]>;
    defaultTermsAndConditionsConsentText?: InputMaybe<Scalars["String"]>;
    defaultTermsText?: InputMaybe<Scalars["String"]>;
    handle?: InputMaybe<Scalars["String"]>;
    image?: InputMaybe<ImageInput>;
    language?: InputMaybe<Scalars["String"]>;
    name?: InputMaybe<Scalars["String"]>;
    whiteLabelImage?: InputMaybe<ImageInput>;
};

export type UploadRequest = {
    __typename?: "UploadRequest";
    fileName: Scalars["String"];
    fileParameterName: Scalars["String"];
    headers: Array<UploadRequestParameter>;
    httpMethod: UploadRequestHttpMethod;
    kind: UploadRequestKind;
    parameters: Array<UploadRequestParameter>;
    provider: Scalars["ID"];
    url: Scalars["String"];
};

export enum UploadRequestHttpMethod {
    Post = "POST",
    Put = "PUT",
}

export enum UploadRequestKind {
    MultipartForm = "MULTIPART_FORM",
    RequestBody = "REQUEST_BODY",
}

export type UploadRequestParameter = {
    __typename?: "UploadRequestParameter";
    key: Scalars["String"];
    value: Scalars["String"];
};

/**   noinspection GraphQLUnresolvedReference,GraphQLMissingType */
export type Void = {
    __typename?: "Void";
    _?: Maybe<Scalars["Boolean"]>;
};

export type ProfileFragmentFragment = {
    __typename?: "Profile";
    id: string;
    url: string;
    name?: string | null;
    shareURL: string;
    brandColor?: string | null;
    brandLink?: string | null;
    image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
};

export type ImageFragmentFragment = { __typename?: "Image"; urlTemplate: any; color?: string | null };

export type AudioFragmentFragment = { __typename?: "Audio"; url: any };

export type PostFragmentFragment = {
    __typename?: "Post";
    id: string;
    url: string;
    status: ResourceStatus;
    shareURL: string;
    caption?: string | null;
    timestampCreated: string;
    timestampUserModified?: string | null;
    rawTranscript?: string | null;
    shareVideoWithTranscriptURL?: string | null;
    contributorName?: string | null;
    link?: { __typename?: "URLPreview"; url: string; title: string; imageURL?: string | null } | null;
    image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
    profile: {
        __typename?: "Profile";
        id: string;
        url: string;
        name?: string | null;
        shareURL: string;
        brandColor?: string | null;
        brandLink?: string | null;
        image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
    };
    audio?: { __typename?: "Audio"; url: any } | null;
    transcript?: {
        __typename?: "Transcript";
        words: Array<{ __typename?: "TranscriptWord"; content: string; timeStart?: number | null; timeEnd?: number | null }>;
    } | null;
};

export type CreatePostMutationVariables = Exact<{
    campaignID: Scalars["String"];
    email?: InputMaybe<Scalars["String"]>;
    name?: InputMaybe<Scalars["String"]>;
    audio?: InputMaybe<AudioInput>;
    answer?: InputMaybe<Scalars["String"]>;
    image?: InputMaybe<ImageInput>;
    externalID?: InputMaybe<Scalars["String"]>;
    rating?: InputMaybe<Scalars["Int"]>;
    followupQuestions?: InputMaybe<Array<InputMaybe<FollowupQuestion>> | InputMaybe<FollowupQuestion>>;
}>;

export type CreatePostMutation = { __typename?: "Mutation"; createPost?: { __typename?: "Void"; _?: boolean | null } | null };

export type CreateTranscribeStreamUrlMutationVariables = Exact<{
    campaignID: Scalars["String"];
}>;

export type CreateTranscribeStreamUrlMutation = {
    __typename?: "Mutation";
    createTranscribeStreamURL: { __typename?: "TranscribeStreamURLResponse"; url: string };
};

export type CreateUploadRequestV2MutationVariables = Exact<{
    assetType: CreateUploadRequestAssetType;
    needsTranscoding?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CreateUploadRequestV2Mutation = {
    __typename?: "Mutation";
    createUploadRequest: {
        __typename: "UploadRequest";
        url: string;
        fileName: string;
        fileParameterName: string;
        httpMethod: UploadRequestHttpMethod;
        provider: string;
        kind: UploadRequestKind;
        parameters: Array<{ __typename: "UploadRequestParameter"; key: string; value: string }>;
        headers: Array<{ __typename: "UploadRequestParameter"; key: string; value: string }>;
    };
};

export type SaveAnalyticsEventMutationVariables = Exact<{
    action: Scalars["String"];
    campaignID: Scalars["String"];
}>;

export type SaveAnalyticsEventMutation = { __typename?: "Mutation"; saveAnalyticsEvent?: { __typename?: "Void"; _?: boolean | null } | null };

export type PostQueryVariables = Exact<{
    postID: Scalars["String"];
}>;

export type PostQuery = {
    __typename?: "Query";
    post: {
        __typename?: "Post";
        id: string;
        url: string;
        status: ResourceStatus;
        shareURL: string;
        caption?: string | null;
        timestampCreated: string;
        timestampUserModified?: string | null;
        rawTranscript?: string | null;
        shareVideoWithTranscriptURL?: string | null;
        contributorName?: string | null;
        link?: { __typename?: "URLPreview"; url: string; title: string; imageURL?: string | null } | null;
        image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
        profile: {
            __typename?: "Profile";
            id: string;
            url: string;
            name?: string | null;
            shareURL: string;
            brandColor?: string | null;
            brandLink?: string | null;
            image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
        };
        audio?: { __typename?: "Audio"; url: any } | null;
        transcript?: {
            __typename?: "Transcript";
            words: Array<{ __typename?: "TranscriptWord"; content: string; timeStart?: number | null; timeEnd?: number | null }>;
        } | null;
    };
};

export type ResourceQueryVariables = Exact<{
    url: Scalars["String"];
}>;

export type ResourceQuery = {
    __typename?: "Query";
    resourceV2: {
        __typename?: "ResourceV2Response";
        resource?:
            | {
                  __typename?: "ResourceCampaignContributionResponse";
                  id: string;
                  promptText?: string | null;
                  termsText: string;
                  privacyText: string;
                  successText?: string | null;
                  successLink?: string | null;
                  successLinkLabel?: string | null;
                  enforcesTermsAndConditionsConsent: boolean;
                  enforcesPrivacyPolicyConsent: boolean;
                  contributionURL: string;
                  hideBeamsBranding: boolean;
                  status: string;
                  color?: string | null;
                  backgroundColor?: string | null;
                  canAcceptResponses: boolean;
                  privacyURL?: string | null;
                  termsURL?: string | null;
                  termsAndConditionsConsentText?: string | null;
                  privacyPolicyConsentText?: string | null;
                  maximumRecordingDuration?: number | null;
                  isNPSCampaign: boolean;
                  NPSQuestion?: string | null;
                  promptSublineText?: string | null;
                  recordButtonLabel?: string | null;
                  isCSATCampaign: boolean;
                  CSATQuestion?: string | null;
                  interfaceLanguage?: string | null;
                  collectNames: CollectUserData;
                  collectEmails: CollectUserData;
                  collectImages: CollectUserData;
                  videoURLs?: Array<string | null> | null;
                  conversationalSurvey: boolean;
                  newRecorder: boolean;
                  agentWelcomeMessage?: string | null;
                  successShareEnabled?: boolean | null;
                  textFieldDefault: boolean;
                  image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
                  profile: {
                      __typename?: "Profile";
                      id: string;
                      url: string;
                      name?: string | null;
                      shareURL: string;
                      brandColor?: string | null;
                      brandLink?: string | null;
                      image?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
                  };
                  backgroundImage?: { __typename?: "Image"; urlTemplate: any; color?: string | null } | null;
              }
            | { __typename?: "ResourcePostOnProfileResponse" }
            | { __typename?: "ResourcePostResponse" }
            | { __typename?: "ResourceProfileResponse" }
            | null;
    };
};

export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
        urlTemplate
        color
    }
`;
export const ProfileFragmentFragmentDoc = gql`
    fragment ProfileFragment on Profile {
        id
        url
        name
        image {
            ...ImageFragment
        }
        shareURL
        brandColor
        brandLink
    }
    ${ImageFragmentFragmentDoc}
`;
export const AudioFragmentFragmentDoc = gql`
    fragment AudioFragment on Audio {
        url
    }
`;
export const PostFragmentFragmentDoc = gql`
    fragment PostFragment on Post {
        id
        url
        status
        shareURL
        link {
            url
            title
            imageURL
        }
        image {
            ...ImageFragment
        }
        caption
        profile {
            ...ProfileFragment
        }
        timestampCreated
        timestampUserModified
        audio {
            ...AudioFragment
        }
        rawTranscript
        shareVideoWithTranscriptURL
        contributorName
        transcript {
            words {
                content
                timeStart
                timeEnd
            }
        }
    }
    ${ImageFragmentFragmentDoc}
    ${ProfileFragmentFragmentDoc}
    ${AudioFragmentFragmentDoc}
`;
export const CreatePostDocument = gql`
    mutation CreatePost(
        $campaignID: String!
        $email: String
        $name: String
        $audio: AudioInput
        $answer: String
        $image: ImageInput
        $externalID: String
        $rating: Int
        $followupQuestions: [FollowupQuestion]
    ) {
        createPost(
            post: {
                audio: $audio
                answer: $answer
                email: $email
                name: $name
                image: $image
                campaignID: $campaignID
                externalID: $externalID
                rating: $rating
                followupQuestions: $followupQuestions
            }
        ) {
            _
        }
    }
`;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePostMutation({
 *   variables: {
 *     campaignID: // value for 'campaignID'
 *     email: // value for 'email'
 *     name: // value for 'name'
 *     audio: // value for 'audio'
 *     answer: // value for 'answer'
 *     image: // value for 'image'
 *     externalID: // value for 'externalID'
 *     rating: // value for 'rating'
 *     followupQuestions: // value for 'followupQuestions'
 *   },
 * });
 */
export function useCreatePostMutation(
    options:
        | VueApolloComposable.UseMutationOptions<CreatePostMutation, CreatePostMutationVariables>
        | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePostMutation, CreatePostMutationVariables>> = {}
) {
    return VueApolloComposable.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
}
export type CreatePostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePostMutation, CreatePostMutationVariables>;
export const CreateTranscribeStreamUrlDocument = gql`
    mutation CreateTranscribeStreamURL($campaignID: String!) {
        createTranscribeStreamURL(campaignID: $campaignID) {
            url
        }
    }
`;

/**
 * __useCreateTranscribeStreamUrlMutation__
 *
 * To run a mutation, you first call `useCreateTranscribeStreamUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscribeStreamUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTranscribeStreamUrlMutation({
 *   variables: {
 *     campaignID: // value for 'campaignID'
 *   },
 * });
 */
export function useCreateTranscribeStreamUrlMutation(
    options:
        | VueApolloComposable.UseMutationOptions<CreateTranscribeStreamUrlMutation, CreateTranscribeStreamUrlMutationVariables>
        | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTranscribeStreamUrlMutation, CreateTranscribeStreamUrlMutationVariables>> = {}
) {
    return VueApolloComposable.useMutation<CreateTranscribeStreamUrlMutation, CreateTranscribeStreamUrlMutationVariables>(
        CreateTranscribeStreamUrlDocument,
        options
    );
}
export type CreateTranscribeStreamUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
    CreateTranscribeStreamUrlMutation,
    CreateTranscribeStreamUrlMutationVariables
>;
export const CreateUploadRequestV2Document = gql`
    mutation CreateUploadRequestV2($assetType: CreateUploadRequestAssetType!, $needsTranscoding: Boolean) {
        createUploadRequest(assetType: $assetType, needsTranscoding: $needsTranscoding) {
            __typename
            url
            parameters {
                __typename
                key
                value
            }
            fileName
            fileParameterName
            httpMethod
            provider
            kind
            headers {
                __typename
                key
                value
            }
        }
    }
`;

/**
 * __useCreateUploadRequestV2Mutation__
 *
 * To run a mutation, you first call `useCreateUploadRequestV2Mutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadRequestV2Mutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUploadRequestV2Mutation({
 *   variables: {
 *     assetType: // value for 'assetType'
 *     needsTranscoding: // value for 'needsTranscoding'
 *   },
 * });
 */
export function useCreateUploadRequestV2Mutation(
    options:
        | VueApolloComposable.UseMutationOptions<CreateUploadRequestV2Mutation, CreateUploadRequestV2MutationVariables>
        | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUploadRequestV2Mutation, CreateUploadRequestV2MutationVariables>> = {}
) {
    return VueApolloComposable.useMutation<CreateUploadRequestV2Mutation, CreateUploadRequestV2MutationVariables>(CreateUploadRequestV2Document, options);
}
export type CreateUploadRequestV2MutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
    CreateUploadRequestV2Mutation,
    CreateUploadRequestV2MutationVariables
>;
export const SaveAnalyticsEventDocument = gql`
    mutation SaveAnalyticsEvent($action: String!, $campaignID: String!) {
        saveAnalyticsEvent(event: { action: $action, campaignID: $campaignID }) {
            _
        }
    }
`;

/**
 * __useSaveAnalyticsEventMutation__
 *
 * To run a mutation, you first call `useSaveAnalyticsEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveAnalyticsEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveAnalyticsEventMutation({
 *   variables: {
 *     action: // value for 'action'
 *     campaignID: // value for 'campaignID'
 *   },
 * });
 */
export function useSaveAnalyticsEventMutation(
    options:
        | VueApolloComposable.UseMutationOptions<SaveAnalyticsEventMutation, SaveAnalyticsEventMutationVariables>
        | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveAnalyticsEventMutation, SaveAnalyticsEventMutationVariables>> = {}
) {
    return VueApolloComposable.useMutation<SaveAnalyticsEventMutation, SaveAnalyticsEventMutationVariables>(SaveAnalyticsEventDocument, options);
}
export type SaveAnalyticsEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
    SaveAnalyticsEventMutation,
    SaveAnalyticsEventMutationVariables
>;
export const PostDocument = gql`
    query Post($postID: String!) {
        post(postID: $postID) {
            ...PostFragment
        }
    }
    ${PostFragmentFragmentDoc}
`;

/**
 * __usePostQuery__
 *
 * To run a query within a Vue component, call `usePostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePostQuery({
 *   postID: // value for 'postID'
 * });
 */
export function usePostQuery(
    variables: PostQueryVariables | VueCompositionApi.Ref<PostQueryVariables> | ReactiveFunction<PostQueryVariables>,
    options:
        | VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>
        | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>>
        | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>> = {}
) {
    return VueApolloComposable.useQuery<PostQuery, PostQueryVariables>(PostDocument, variables as any, options as any);
}
export function usePostLazyQuery(
    variables: PostQueryVariables | VueCompositionApi.Ref<PostQueryVariables> | ReactiveFunction<PostQueryVariables>,
    options:
        | VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>
        | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>>
        | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostQuery, PostQueryVariables>> = {}
) {
    return VueApolloComposable.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, variables as any, options as any);
}
export type PostQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PostQuery, PostQueryVariables>;
export const ResourceDocument = gql`
    query Resource($url: String!) {
        resourceV2(url: $url) {
            resource {
                ... on ResourceCampaignContributionResponse {
                    id
                    promptText
                    termsText
                    privacyText
                    successText
                    successLink
                    successLinkLabel
                    enforcesTermsAndConditionsConsent
                    enforcesPrivacyPolicyConsent
                    contributionURL
                    hideBeamsBranding
                    status
                    color
                    backgroundColor
                    image {
                        ...ImageFragment
                    }
                    profile {
                        ...ProfileFragment
                    }
                    canAcceptResponses
                    privacyURL
                    termsURL
                    termsAndConditionsConsentText
                    privacyPolicyConsentText
                    maximumRecordingDuration
                    backgroundImage {
                        ...ImageFragment
                    }
                    isNPSCampaign
                    NPSQuestion
                    promptSublineText
                    recordButtonLabel
                    isCSATCampaign
                    CSATQuestion
                    interfaceLanguage
                    collectNames
                    collectEmails
                    collectImages
                    videoURLs
                    conversationalSurvey
                    newRecorder
                    agentWelcomeMessage
                    successShareEnabled
                    textFieldDefault
                }
            }
        }
    }
    ${ImageFragmentFragmentDoc}
    ${ProfileFragmentFragmentDoc}
`;

/**
 * __useResourceQuery__
 *
 * To run a query within a Vue component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourceQuery({
 *   url: // value for 'url'
 * });
 */
export function useResourceQuery(
    variables: ResourceQueryVariables | VueCompositionApi.Ref<ResourceQueryVariables> | ReactiveFunction<ResourceQueryVariables>,
    options:
        | VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>
        | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>>
        | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>> = {}
) {
    return VueApolloComposable.useQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, variables as any, options as any);
}
export function useResourceLazyQuery(
    variables: ResourceQueryVariables | VueCompositionApi.Ref<ResourceQueryVariables> | ReactiveFunction<ResourceQueryVariables>,
    options:
        | VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>
        | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>>
        | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourceQuery, ResourceQueryVariables>> = {}
) {
    return VueApolloComposable.useLazyQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, variables as any, options as any);
}
export type ResourceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourceQuery, ResourceQueryVariables>;
